import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import ContractorsPage from '../pages/ContractorsPage';
import ContractorProfilePage from '../pages/ContractorProfilePage';
import { Container, Typography, CircularProgress, Button } from '@mui/material';

const ContractorsRouter = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Show loading state while authentication is being checked
  if (isLoading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>Loading...</Typography>
      </Container>
    );
  }

  // Logged-out visitors browse the public contractor directory — the page
  // gates every action (request quotation, message) behind login itself.
  if (!isAuthenticated || !user) {
    return <ContractorsPage />;
  }

  // Route to appropriate page based on user role
  switch (user.role?.toLowerCase()) {
    case 'contractor':
      // Contractors see their own profile management page
      return <ContractorProfilePage />;
    
    case 'admin':
      // Redirect admins to their admin dashboard
      return (
        <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Admin Access Restricted
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Use the Admin Dashboard to manage users, contractors, and platform oversight.
          </Typography>
          <Button 
            variant="contained" 
            href="/admin/dashboard"
            sx={{ mt: 2 }}
          >
            Go to Admin Dashboard
          </Button>
        </Container>
      );
    
    case 'client':
    case 'verifier':
    case 'quality_inspector':
    default:
      // Others see the contractor directory for hiring
      return <ContractorsPage />;
  }
};

export default ContractorsRouter; 
